import {Component, QueryList, ViewChildren} from "@angular/core";
import {BaseComponent} from "../BaseComponent";
import {DxDrawerComponent} from "devextreme-angular";

@Component({
  selector: '',
  template: 'NO-UI',
})
export abstract class BaseComponentWithDrawer extends BaseComponent {

  @ViewChildren(DxDrawerComponent) drawers?: QueryList<DxDrawerComponent>;

  isDrawerOpen = false;

  protected prevClientWidth = 0;

  ngOnDestroy() {
    super.ngOnDestroy();
    window.removeEventListener('resize', this.onResize.bind(this));
  }

  setWidthOfDrawerPx(): number {
    if (this.appService.isMobileScreen()) {
      return document.documentElement.clientWidth - 20;
    } else if (this.appService.isSmallScreen()) {
      return document.documentElement.clientWidth * 0.8 - 20;
    } else {
      return document.documentElement.clientWidth * 0.5 - 20;
    }
  }


  setWidthOfDrawerVw(): number {

    if (this.appService.isMobileScreen()) {
      return 100;
    } else if (this.appService.isSmallScreen()) {
      return 80;
    } else {
      return 50;
    }
  }

  subscribeToWindowResize(): void {
    window.addEventListener('resize', this.onResize.bind(this), false);
  }

  onResize() {
    new Promise(
      (resolve) => {
        setTimeout(() => resolve(true), 0);
      }).then(
      () => {
        if (!!this.drawers) {
          this.drawers?.forEach(
            (drawer) => {
              const oldWidth = drawer.width;
              drawer.width = 0;
              this.cdr.detectChanges();
              if (!!oldWidth)
                drawer.width = oldWidth;
              else
                drawer.width = "100%";
            }
          )
        }
        this.cdr.detectChanges();
      }
    );
  }

}
